<template>
    <v-navigation-drawer v-model="show" :clipped="clipped" app fixed>
        <v-list-item-group :value="selectedItem">
            <v-img src="/logo_circle.png" height="100px" contain class="my-7"></v-img>
            <v-list nav dense :rounded="rounded">
                <template v-for="(item, i) in menu">
                    <!-- Single item -->
                    <v-list-item v-if="!item.items" :key="i" :href="item.url" v-bind="item.bind || {}" link :value="i"
                        :active-class="activeClass">
                        <v-list-item-action>
                            <v-icon v-if="item.icon" :color="item.color" v-text="item.icon"></v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title v-text="item.name"></v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <!-- Group item -->
                    <v-list-group v-else :key="i" :prepend-icon="item.icon" :href="item.url" v-bind="item.bind || {}"
                        :value="selectedItem === i" :active-class="activeClass">
                        <template v-slot:activator>
                            <v-list-item-content>
                                <v-list-item-title :href="item.url" v-text="item.name"></v-list-item-title>
                            </v-list-item-content>
                        </template>


                        <v-list-item v-for="(subItem, k) in item.items" :key="i + '-' + k" :value="i + '-' + k"
                            :href="subItem.url" link
                            :class="{ 'v-list-item--active': selectedSubItem === i + '-' + k, [activeClass]: selectedSubItem === i + '-' + k, [subItemsClass]: true }"
                            :active-class="activeClass">

                            <v-list-item-action>
                                <v-icon v-if="subItem.icon" v-text="subItem.icon"></v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title v-text="subItem.name"></v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                    </v-list-group>
                    <!-- /Group item -->
                </template>
            </v-list>
        </v-list-item-group>
    </v-navigation-drawer>
</template>
<script>
import { mapGetters } from 'vuex'; //Vuex getter map

function isActiveMenuItem(item) {
    return item.match ?
        location.pathname.match(new RegExp(item.match)) :
        (item.exact ?
            (location.pathname === (item.url) || location.href === (item.url) || location.href === (item.url) + '/') :
            (location.pathname.startsWith(item.url) || location.href.startsWith(item.url))
        );
}
export default {
    props: {
        clipped: { type: Boolean, default: false },
        value: { required: true },
        rounded: {},
        activeClass: { default: '' },
        subItemsClass: { default: 'pl-2' },
    },
    computed: {
        show: {
            get() { return this.value; },
            set(v) { this.$emit('input', v); }
        },
        ...mapGetters({
            menu: 'mainMenu',
        }),
        selectedItem() {
            for (let index in this.menu) {
                let item = this.menu[index];
                if (isActiveMenuItem(item))
                    return parseInt(index);
            }

            return null;
        },
        selectedSubItem() {
            let index = this.selectedItem;
            let currentItem = index && this.menu[index];
            if (currentItem && currentItem.items) {
                for (let subIndex in currentItem.items) {
                    let subItem = currentItem.items[subIndex];

                    console.warn('selectedSubItem', JSON.stringify({
                        currentItem, subItem,
                        selectedItem: this.selectedItem,
                        active: isActiveMenuItem(subItem),
                    }))
                    if (isActiveMenuItem(subItem))
                        return index + '-' + subIndex;
                }
            }
            return null;
        },
    },
    methods: {
    },
    filters: {
        isActive(item) {
            return isActiveMenuItem(item);
        },
    }
}
</script>
